import { render } from "./global_notice_list.vue?vue&type=template&id=5e034d4c"
import script from "./global_notice_list.js?vue&type=script&lang=js&external"
export * from "./global_notice_list.js?vue&type=script&lang=js&external"

import "./global_notice_list.vue?vue&type=style&index=0&id=5e034d4c&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__